import { ReactComponent as NoImageSquareSvg } from '../../assets/images/no-image-square.svg';

export const NoImageSquareIcon: SvgIcon = (props) => {
    return <NoImageSquareSvg {...props} />;
};
